"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleCount = handleCount;
exports.runAllExpressionsForEachInstance = runAllExpressionsForEachInstance;
const pi_syntax_tools_1 = require("@icg360/pi-syntax-tools");
const create_initial_state_1 = require("../init/create-initial-state");
const reference_tables_1 = require("../reference-tables");
const execute_expressions_1 = require("./execute-expressions");
const execute_syntax_1 = require("./execute-syntax");
function handleCount(state, exp) {
    const context = (0, pi_syntax_tools_1.getContext)({
        ...state,
        this: { iterable: state.iterables[exp.iterableName] },
    });
    const count = Number((0, execute_syntax_1.tryExecSyntaxForExpression)(exp.syntax, context, exp));
    if (Number.isNaN(count)) {
        throw new Error(`Invalid count for iterable ${exp.iterableName}`);
    }
    const safeCount = Math.min(Math.max(0, Math.ceil(count)), state.iterables[exp.iterableName].max);
    state.iterables[exp.iterableName].count = safeCount;
    // Check if the count for this iterable has been updated.
    if (safeCount === state.iterables[exp.iterableName].instances.length) {
        return;
    }
    // If it doesn't match the length of the
    // instances then we need to add or remove instances.
    const affectedIndexes = [];
    const { model, formMetaState, nodeToKey } = reference_tables_1.referenceTables[state.key];
    while (safeCount > state.iterables[exp.iterableName].instances.length) {
        const indexToAdd = state.iterables[exp.iterableName].instances.length;
        state.iterables[exp.iterableName].instances.push((0, create_initial_state_1.createIterableInstance)(model, formMetaState, nodeToKey, exp.iterableName, indexToAdd));
        affectedIndexes.push(indexToAdd);
    }
    while (safeCount < state.iterables[exp.iterableName].instances.length) {
        state.iterables[exp.iterableName].instances.pop();
    }
    runAllExpressionsForEachInstance(state, model.iterables[exp.iterableName], affectedIndexes);
}
function runAllExpressionsForEachInstance(state, iterable, iterableIndexes) {
    // Get all the expressions that depend on terms in this iterable.
    // Put the in a set to avoid duplicates.
    const queueExpressions = new Set();
    for (const termName of Object.keys(iterable.terms)) {
        const dependendents = reference_tables_1.referenceTables[state.key].termDependents.iterables[iterable.name]?.terms[termName];
        if (!dependendents) {
            continue;
        }
        for (const exp of dependendents) {
            queueExpressions.add(exp);
        }
    }
    // Iterate through all the expressions because this is the correct order,
    // but also because we need to execute any expression in the iterable itself
    // that didn't have any dependencies.
    for (const exp of reference_tables_1.referenceTables[state.key].sortedReactiveExpressions) {
        const currentIterable = exp.iterableName === iterable.name;
        if ((currentIterable && exp.type !== "count") ||
            queueExpressions.has(exp)) {
            if (exp.iterableInstanceDeps[iterable.name] === "all") {
                (0, execute_expressions_1.executeExpression)(state, exp);
                continue;
            }
            if (iterableIndexes.length > 0) {
                for (const iterableIndex of iterableIndexes) {
                    execute_expressions_1.Expressions.execute(state, exp, currentIterable
                        ? { iterableName: iterable.name, iterableIndex }
                        : undefined);
                }
            }
        }
    }
}
//# sourceMappingURL=iterable-count.js.map